import { BaseModel } from './BaseModel';
import LearningUnit from './LearningUnit';

export class Certificate extends BaseModel {
  static get entity() {
    return 'certificates';
  }

  static get fk() {
    return 'certificate_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      accredible_group_id: this.string(''),
      learning_unit_id: this.attr(null),
      learning_unit: this.belongsTo(LearningUnit, 'learning_unit_id')
    };
  }

  static apiConfig = {
    actions: {
      fetch(params) {
        return this.get(`/certificates`, { params });
      },

      fetchById(id) {
        return this.get(`/certificates/${id}`);
      },

      create(body) {
        return this.post(`/certificates`, body);
      },

      update(id, body) {
        return this.put(`/certificates/${id}`, body);
      }
    }
  };
}

export default Certificate;
